var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.67725C10.83 10.0299 11.3334 10.4926 11.3334 10.9999C11.3334 12.1046 8.94535 12.9999 6.00002 12.9999C3.05469 12.9999 0.666687 12.1046 0.666687 10.9999C0.666687 10.4932 1.17002 10.0292 2.00002 9.67725",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.508 10.7833L6 10.3333L5.508 10.7833ZM6.492 10.7833L6.49533 10.7799L6.50333 10.7706L6.53333 10.7373L6.644 10.6133C7.19796 9.98235 7.72038 9.32444 8.20933 8.64192C8.63733 8.04192 9.076 7.36192 9.41 6.68659C9.73667 6.02659 10 5.30059 10 4.62925C10 2.24725 8.25467 0.333252 6 0.333252C3.74533 0.333252 2 2.24659 2 4.62925C2 5.30059 2.26333 6.02659 2.59 6.68659C2.924 7.36192 3.36333 8.04192 3.79 8.64192C4.31163 9.36938 4.8713 10.0688 5.46667 10.7373L5.49667 10.7706L5.50467 10.7799L5.508 10.7833C5.57046 10.8516 5.64647 10.9061 5.73118 10.9434C5.81588 10.9808 5.90743 11.0001 6 11.0001C6.09257 11.0001 6.18412 10.9808 6.26882 10.9434C6.35353 10.9061 6.42954 10.8516 6.492 10.7833V10.7833ZM6 10.3333L6.492 10.7826L6 10.3333ZM6 2.99992C5.64638 2.99992 5.30724 3.14039 5.05719 3.39044C4.80714 3.64049 4.66667 3.97963 4.66667 4.33325C4.66667 4.68687 4.80714 5.02601 5.05719 5.27606C5.30724 5.52611 5.64638 5.66659 6 5.66659C6.35362 5.66659 6.69276 5.52611 6.94281 5.27606C7.19286 5.02601 7.33333 4.68687 7.33333 4.33325C7.33333 3.97963 7.19286 3.64049 6.94281 3.39044C6.69276 3.14039 6.35362 2.99992 6 2.99992V2.99992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c4160a2c05e80173bf00bafb406eb416.svg";
export { ForwardRef as ReactComponent };